const IP_URL = process.env.REACT_APP_NODE_API_URL

export const logout = async (user_sesion_id) => {
  try {
    /*
    const response = await fetch(IP_URL + "api_login/logout", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_sesion_id: user_sesion_id }),
    });
    const data = await response.json();
    */
    localStorage.removeItem("token_jwt");
    window.location.href = "/";
  } catch (error) {
    //console.error("Error al iniciar sesión", error);
    var aux = 0;
  }
};
